/**
 * The unauthenticated company job board.
 *
 * One round trip renders every card on `/public-short-form/{companyId}`.
 * `description` and `publicQuestions` are deliberately absent — both are lazy
 * relation resolvers, so folding them in would turn a 12-job board into ~37
 * queries. They are fetched per job by GET_JOB_LISTING_BY_TRACKING_LINK once a
 * card is actually opened, and cached by Apollo from then on.
 */
export const GET_PUBLIC_JOB_BOARD = gql`
  query PublicJobBoard($companyId: String!) {
    publicJobBoard(companyId: $companyId) {
      companyName
      cards {
        jobListingId
        title
        subtitle
        type
        payMin
        payMax
        payUnit
        payCurrency
        employmentType
        licenseClass
        minMonthsExperience
        address {
          city
          state
        }
        trackingLink
      }
    }
  }
`
